import Phaser from 'phaser';
import './ui/styles/main.css';
import { createGame } from './game/main';

// Initialize Phaser game
const game = createGame();

// Log game info
console.log('Bookbothy started', {
  version: '0.1.0',
  phaser: Phaser.VERSION,
  canvas: `${String(game.config.width)}×${String(game.config.height)}`,
});
